import React, { useState } from 'react';
import { IconButton, Box } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { CS_API_URL } from '../../lib/env';
import Axios from 'axios';
import { getMaskedPhone } from '../../lib/util';
import Loader from '../ui/loaders/Loader';

const goByLink = (link) => {
  const a = document.createElement('a');
  a.target = '_blank';
  a.href = link;
  a.click();
  a.remove();
};

export default function PhoneMaskButton({ phoneNumber, saleId, maskChar = 'X' }) {
  const [show, setShow] = useState();
  const [loading, setLoading] = useState({ call: false, show: false });
  const { enqueueSnackbar } = useSnackbar();

  if (!phoneNumber) {
    return null;
  }

  const handleCall = async (event) => {
    event.stopPropagation();
    if (loading.call) {
      return;
    }
    setLoading({ ...loading, call: true });
    try {
      await Axios.post(
        `${CS_API_URL}/call/registerCall`,
        { saleId, phoneNumber, contactViews: 'call' },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem('token')}`,
          },
        }
      );
      goByLink(`tel:${phoneNumber}`);
    } catch (error) {
      console.log(error)
    }
    setLoading({ ...loading, call: false });
  };

  const handleToggle = async (event) => {
    event.stopPropagation();
    if (show) {
      setShow(false);
      return;
    }
    setLoading({ ...loading, show: true });
    try {
      await Axios.post(
        `${CS_API_URL}/call/registerCall`,
        { saleId, phoneNumber, contactViews: 'show' },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem('token')}`,
          },
        }
      );
      setShow(!show);
    } catch (error) {
      console.log(error)
    }
    setLoading({ ...loading, show: false });
  };

  const Icon = show ? VisibilityOff : Visibility;
  const phoneMasked = show ? phoneNumber : getMaskedPhone(phoneNumber);

  return (
    <Box component='span' display='inline-flex' alignItems='center'>
      {loading.call && <Loader size={18} style={{ padding: 0, margin: 0 }} />}
      <Box component='a' mr={1} href={'#'} onClick={handleCall}>
        {phoneMasked}
      </Box>
      {loading.show ? (
        <Loader size={18} style={{ padding: 0, margin: 0 }} />
      ) : (
        <IconButton style={{ zIndex: 2, marginBottom: 0 }} size='small' type='button' onClick={handleToggle}>
          <Icon fontSize='inherit' style={{ zIndex: 2 }} />
        </IconButton>
      )}
    </Box>
  );
}
